import script from "./CategoryManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryManagementView.vue?vue&type=script&setup=true&lang=js"

import "./CategoryManagementView.vue?vue&type=style&index=0&id=57ffff12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ffff12"]])

export default __exports__